import Backdrop from "@mui/material/Backdrop";

const FullWidthLoader = ({ open }) => {
    return (
        <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
            open={open}
        >
            <span className="loader"></span>
        </Backdrop>
    );
};

export default FullWidthLoader;
